import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from '@material-ui/core/Button'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// Shared components
import Paper from 'components/Paper';
import MaterialTableComponent from '../../../../../utils/MaterialTable'
import {getSpecialMethod} from '../../../../../services/specials/getSpecial'
import {stackLineChart} from '../../../../../utils/HighchartJson/DualChart/stackAndLineChart'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import Loading from '../../../../../utils/Loading'
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'

//CAMBIA EL COLOR DE LA LEYENDA
(function(H) {
  H.wrap(H.Legend.prototype, 'colorizeItem', function(proceed, item, visible) {
      var color = item.color;

      item.color = item.options.legendColor;
      proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      item.color = color;
  });
}(Highcharts));

class ObjectiveComparative extends Component {
  constructor(props) {
        
    super(props);
    //console.log(props)
    this.docToPrint=React.createRef();
    this.state = {
      nameObjective:this.props.dataSpecialObjective.nameObjective,
      namePeriod:this.props.dataSpecialObjective.namePeriod,
      objective:this.props.dataSpecialObjective.objective,
      error:false,
      load:true,
      period: this.props.dataSpecialObjective.period,
      statePeriod:this.props.dataSpecialObjective.statePeriod,
      chartOptions: this.chartOptions,
      pdf:this.props.dataSpecialObjective.pdf
    }
  }

  componentDidMount() {
    this.getDataFromAPI();
  }

  static getDerivedStateFromProps(props, state) {
    if(props.dataSpecialObjective.period!==state.period||props.dataSpecialObjective.statePeriod!==state.statePeriod){
      return{
        load:true,
        period:props.dataSpecialObjective.period,
        statePeriod:props.dataSpecialObjective.statePeriod,
        namePeriod:props.dataSpecialObjective.namePeriod
      }
    }
    return null;
}
componentDidUpdate(prevProps, prevState) {
    if(prevState.period!== this.state.period||prevState.statePeriod!== this.state.statePeriod){
        this.getDataFromAPI();
    }
}

  getDataFromAPI=()=>{
    const {objective, period, statePeriod}=this.state
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    const method=sessionStorage.getItem("methodSpecial")
    var begin=null
    var final=null
    if(period==="c"){
      begin=moment(statePeriod.startDate).format("YYYY-MM-DD")
      final=moment(statePeriod.endDate).add("days","1").format("YYYY-MM-DD")
    }
    const startDate = moment().subtract({"months":1}).startOf('month')
    let month = startDate.month() + 1
    let year = startDate.year()
    getSpecialMethod(objective,user, token, method, month, year, period, begin, final).then( value =>{
        try {
            this.processData(value)
                    
        } catch (error) {
            this.setState({
                error: true,
            });
        }
    })
  }

  processData=(data)=>{
    const {objective}=this.state
    var listAvailability=[]
    var listParcial=[]
    var listDowntime=[]
    var listResponse=[]
    var listNameObj=[]
    var listColor=[]
    var dataEle=[]
    data.map(ele=>{
      listAvailability.push(ele.disponibilidad.uptime)
      listParcial.push(ele.disponibilidad.parcial)
      listDowntime.push(ele.disponibilidad.downtime)
      listResponse.push(ele.rendimiento)
      listNameObj.push(ele.paso.nombre_paso+"-"+ele.nombreObjetivo)
      dataEle.push({"disponibilidad":parseFloat((ele.disponibilidad.uptime+ele.disponibilidad.parcial).toFixed(2)),
                    "uptime":ele.disponibilidad.uptime,
                    "parcial":ele.disponibilidad.parcial,
                    "rendimiento":ele.rendimiento,
                    "nombreObjetivo":ele.nombreObjetivo,
                    "downtime":ele.disponibilidad.downtime})
    })
    var jsonChart =stackLineChart(listAvailability,listParcial, listDowntime, listResponse, listNameObj, "", 'Uptime', 'Parcial', 'Downtime', 'Tiempo de Respuesta', '%', 's', '')
    this.setState({
      load: false,
      chart:jsonChart,
      keys:[{"title":'Nombre serie', 'field':'nombreObjetivo'},
            {"title":"Tiempo de Respuesta",'field':"rendimiento"},
            {"title":"Uptime Total",'field':'disponibilidad'},
            {"title":"Uptime Global",'field':'uptime'},
            {"title":"Uptime Parcial",'field':'parcial'},
            {"title":"Downtime",'field':"downtime"},
          ],
      materialData:dataEle
    })
  }

  print=()=>{
    const input0 = this.docToPrint.current;
    const {namePeriod, nameObjective}=this.state
    var list=[input0]
    var doc = new jsPDF();
    const tasks = list.map(tab => html2canvas(tab))

    Promise.all(tasks).then(canvases =>{
        for (const canvas of canvases){
            var left=20
            var up=70
            var right=160
            var down= 140
            const imgDataI = canvas.toDataURL('image/png');
            doc.addImage(imgDataI, 'PNG', left, up, right, down);//componente
        }
        doc.save(nameObjective+"-"+namePeriod);
        this.setState({
            loadPdf:false,
        })
    })
  }
  
  render() {
    const { classes, className, ...rest } = this.props;
    const {load, chart, materialData, keys}=this.state
    
    if(load){
      return (
        <Grid
          container
          spacing={10}
        >
          <Loading />
        </Grid>
      );
    }else{
      return (
        <Grid
        container
        spacing={5}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          xl={12}
          style={{textAlign:"right"}}
        >
          <Button onClick={this.print}><Typography variant="button">Imprimir</Typography></Button>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          xl={12}
          style={{textAlign:"center"}}
          ref={this.docToPrint}  
        >
          {/*<Typography style={{color:"rgb(102, 120, 138)"}} variant="h3">Comparativo</Typography>*/}
          <PerfectScrollbar>
            <HighchartsReact
                highcharts={Highcharts}
                options={chart} />
          </PerfectScrollbar>
        </Grid>
        <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{textAlign:"center"}}
              >
                <MaterialTableComponent keys={keys} data={materialData} />
              </Grid>
      </Grid>
      )
          
        
      
    }
    
  }
}

ObjectiveComparative.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ObjectiveComparative);